import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { useLoading } from '@pok/weblib/context/loading-context.jsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../icons/CloseIcon';
import LinkedinProfileButton from '../LinkedinProfileButton.jsx';
import { removeExecuteAttemptToAddToLinkedinProfile } from '../../utils/sessionStorage.js';
import { loadOrganization } from '../../interact.jsx';
import ShareIcon from '../../assets/images/share/ShareProfile.svg';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { registerShareAction } from '../../utils/google-analytics.js';

export default function LinkedinProfileDialog({ open, onClose, certificate }) {
    const { t } = useTranslation();
    const { showLoading } = useLoading();
    const [org, setOrg] = useState(undefined);

    useEffect(() => {
        if (open)
            loadOrganization(certificate.minter).then((x) => {
                setOrg(x);
            });
    }, []);

    const _onClose = () => {
        removeExecuteAttemptToAddToLinkedinProfile(certificate.id);
        onClose();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={_onClose}
                sx={{
                    '& .MuiPaper-root': {
                        padding: 4,
                        paddingBottom: 0,
                        borderRadius: '16px',
                        maxWidth: '600px',
                    },
                }}
            >
                <DialogTitle>
                    <Stack direction={'row'} justifyContent={'center'}>
                        <img alt="share" src={ShareIcon} />
                        <span
                            onClick={_onClose}
                            style={{ position: 'absolute', right: 12, top: 12, cursor: 'pointer' }}
                        >
                            <CloseIcon />
                        </span>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText component="span">
                        <Stack direction={'column'} spacing={2} justifyContent={'center'} paddingTop={2}>
                            <Typography component="span" variant="h3">
                                {t('certificate.share.linkedin.profile.ask.title')}
                            </Typography>
                            <Typography component="span" variant="body11">
                                {t('certificate.share.linkedin.profile.ask.subtitle')}
                            </Typography>
                        </Stack>
                        <Stack direction={'row'} spacing={2} justifyContent={'center'} paddingTop={2}>
                            <Button
                                variant="outlined"
                                sx={{ borderRadius: 2, border: '2px solid #5124A6' }}
                                onClick={_onClose}
                            >
                                {t('certificate.share.linkedin.profile.ask.later_button')}
                            </Button>
                            <LinkedinProfileButton
                                organization={org}
                                onSendEvent={(method) => {
                                    registerShareAction('post-'.concat(method));
                                    _onClose();
                                }}
                                outstanding={true}
                                cert={certificate}
                            />
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ alignSelf: 'center', marginBottom: '16px' }}></DialogActions>
            </Dialog>
        </>
    );
}
